import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { SiteSelectors } from '@next/core-lib/site';
import { Store } from '@ngrx/store';

import { Application } from '../../shared/models/authorizationService.model';
import { AppWizardModuleState } from '../models/app-wizard.model';
import { deleteApplication, getApplications } from '../store/actions/app-wizard.actions';

import { selectApplications } from '../store/selectors/app-wizard.selectors';

@Component({
  selector: 'app-wizard-delete',
  templateUrl: './app-wizard-delete.component.html',
  styleUrls: ['./app-wizard-delete.component.scss'],
  standalone: false,
})
export class AppWizardDeleteComponent implements OnInit {
  @ViewChild(MatStepper) stepper: MatStepper;

  pageTitle$ = this.store.select(SiteSelectors.selectPageTitle);
  applications$ = this.store.select(selectApplications);
  applicationFormGroup = this.formBuilder.group({
    appNameCtrl: ['', Validators.required],
  });
  key: string;

  constructor(
    private readonly store: Store<AppWizardModuleState>,
    private formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(getApplications());
  }

  complete() {
    this.key = (this.applicationFormGroup.get('appNameCtrl').getRawValue() as Application)
      .key as string;
    this.store.dispatch(deleteApplication({ key: this.key }));
    this.store.dispatch(getApplications());
    this.stepper.next();
  }
}
